import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FileX, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-not-found-page',
  imports: [LucideAngularModule, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './not-found-page.component.html',
})
export class NotFoundPageComponent {
  readonly icon = FileX;
}
